class makeCanvas {
  constructor(sourceId, targetId, options = {}) {
    this.sourceElement = document.getElementById(sourceId);
    this.targetElement = document.getElementById(targetId);
    this.canvas = document.createElement("canvas");
    this.ctx = this.canvas.getContext("2d");

    // Default options
    this.options = {
      scale: 1, // Scale the canvas (default 1, means no scaling)
      wordWrap: false, // Option to enable word wrapping for text rendering
      ...options, // Merge any passed options
    };

    this.initCanvas();
    this.renderText();
    this.insertCanvas();

    // Watch for resize events on the source element
    window.addEventListener("resize", () => this.updateCanvasSize());
  }

  initCanvas() {
    if (!this.sourceElement || !this.targetElement) return;

    const rect = this.sourceElement.getBoundingClientRect();
    this.canvas.width = rect.width * this.options.scale;
    this.canvas.height = rect.height * this.options.scale;
    this.applyStyles();
  }

  updateCanvasSize() {
    const rect = this.sourceElement.getBoundingClientRect();
    this.canvas.width = rect.width * this.options.scale;
    this.canvas.height = rect.height * this.options.scale;
    this.applyStyles();
    this.renderText(); // Re-render text after resizing
  }

  applyStyles() {
    const styles = window.getComputedStyle(this.sourceElement);
    this.ctx.fillStyle = styles.backgroundColor;
    this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
    this.ctx.strokeStyle = styles.borderColor;
    this.ctx.lineWidth = parseFloat(styles.borderWidth) || 0;
    if (this.ctx.lineWidth > 0) {
      this.ctx.strokeRect(0, 0, this.canvas.width, this.canvas.height);
    }
  }

  renderText() {
    const styles = window.getComputedStyle(this.sourceElement);
    this.ctx.font = `${styles.fontSize} ${styles.fontFamily}`;
    this.ctx.fillStyle = styles.color;
    this.ctx.textBaseline = "top";

    let text = this.sourceElement.innerText.trim();
    const padding = 10;
    const maxWidth = this.canvas.width - padding * 2;

    if (this.options.wordWrap) {
      this.wrapText(text, padding, padding, maxWidth);
    } else {
      this.ctx.fillText(text, padding, padding);
    }
  }

  wrapText(text, x, y, maxWidth) {
    const words = text.split(" ");
    let line = "";
    let lineHeight =
      parseFloat(window.getComputedStyle(this.sourceElement).lineHeight) || 20;

    for (let i = 0; i < words.length; i++) {
      let testLine = line + words[i] + " ";
      let testWidth = this.ctx.measureText(testLine).width;

      if (testWidth > maxWidth) {
        this.ctx.fillText(line, x, y);
        line = words[i] + " ";
        y += lineHeight;
      } else {
        line = testLine;
      }
    }
    this.ctx.fillText(line, x, y); // Render the last line
  }

  insertCanvas() {
    if (this.targetElement) {
      this.targetElement.appendChild(this.canvas);
    }
  }

  clearCanvas() {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
  }
}

class callMakeCanvas {
  _call(sourceId, targetId) {
    // Example usage:
    const canvasCopy = new makeCanvas(sourceId, targetId);
    canvasCopy.renderText();
    canvasCopy.insertCanvas();
  }
}
export default new callMakeCanvas();
